// The school pilot modal.
//
// Opened from four places – the landing band, the Institution price card, the
// account menu and the billing page – so it lives here rather than in any one
// of them, and binds by attribute instead of by id.
(function () {
    'use strict';

    const modal = document.getElementById('pilot-modal');
    if (!modal) return;

    const card = modal.querySelector('.pilot-modal-card');
    const form = document.getElementById('pilot-form');
    const bodyEl = document.getElementById('pilot-modal-body');
    const doneEl = document.getElementById('pilot-done');
    const errorEl = document.getElementById('pilot-error');
    const submit = document.getElementById('pilot-submit');

    // Where the application came from. A teacher already paying for this out of
    // their own pocket is a different conversation from a cold enquiry, and the
    // opener is the only place that knows which one this is.
    const ALLOWED = ['landing', 'pricing', 'app', 'billing', 'direct'];
    let source = 'direct';
    // Read now: by the time the form is sent the app has rewritten the address.
    const landing = window.location.search;
    // Who to hand focus back to when it closes.
    let opener = null;

    function open(from, trigger) {
        source = ALLOWED.indexOf(from) === -1 ? 'direct' : from;
        opener = trigger || null;
        // Deliberately not reset back to the form once it has been sent: someone
        // who closes the confirmation and clicks the button again is usually
        // checking it worked, and re-showing an empty form invites a second
        // application for the same school.
        modal.hidden = false;
        // The scale-in only plays if the class lands on a frame after the
        // element is displayed.
        requestAnimationFrame(() => card.classList.add('is-open'));
        document.body.style.overflow = 'hidden';
        const first = form.hidden ? doneEl : form.elements.schoolName;
        first?.focus({ preventScroll: true });
    }

    function close() {
        card.classList.remove('is-open');
        modal.hidden = true;
        document.body.style.overflow = '';
        opener?.focus?.();
        opener = null;
    }

    // Anything, anywhere, that says it opens this.
    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-pilot-open]');
        if (!trigger) return;
        e.preventDefault();
        open(trigger.getAttribute('data-pilot-open'), trigger);
    });
    // The same entry point for code that has no element to hang it off – the
    // account menu item, which closes its own dropdown first.
    window.openPilotModal = (from) => open(from);

    document.getElementById('pilot-modal-close')?.addEventListener('click', close);
    modal.querySelector('.pilot-done-close')?.addEventListener('click', close);
    modal.addEventListener('click', (e) => {
        if (e.target.classList.contains('pilot-modal-backdrop')) close();
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.hidden) close();
    });

    // Tab must not walk out of an open dialog and into the page behind it.
    modal.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') return;
        const focusable = card.querySelectorAll(
            'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        const live = [...focusable].filter(el => el.offsetParent !== null);
        if (!live.length) return;
        const first = live[0], last = live[live.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        errorEl.hidden = true;

        const data = Object.fromEntries(new FormData(form).entries());
        data.source = source;
        data.landing = landing;

        // Checked here as well as on the server so the three fields that matter
        // are pointed at rather than described. The server trusts none of it.
        const missing = ['schoolName', 'contactName', 'email'].find(k => !String(data[k] || '').trim());
        if (missing) {
            errorEl.textContent = 'Please fill in your school, your name and your email address.';
            errorEl.hidden = false;
            form.elements[missing]?.focus();
            return;
        }

        submit.disabled = true;
        const original = submit.textContent;
        submit.textContent = 'Sending…';

        try {
            const res = await fetch('/api/pilot/apply', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            });
            const body = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(body.error || 'Something went wrong. Please try again.');

            bodyEl.hidden = true;
            doneEl.hidden = false;
            doneEl.focus({ preventScroll: true });
            window.fbq?.('track', 'Lead');
            window.ttq?.track('Lead');
        } catch (err) {
            errorEl.textContent = err.message || 'Something went wrong. Please try again, or email enquire@blueacorn.org.';
            errorEl.hidden = false;
            submit.disabled = false;
            submit.textContent = original;
        }
    });
})();
